module.exports = __webpack_public_path__ + "img/dehsen.com-content-creation_and_layout.fdf2db9b.jpg";